import { Component } from '@angular/core';
import { ColumnTypesEnum } from '@r1-development/rps-shared-ui';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'app-date-cell',
    templateUrl: './date-cell.component.html',
    standalone: false
})
export class DateCellComponent implements ICellRendererAngularComp {
  value: any;
  notAvailable = ColumnTypesEnum.NotAvailable;
  agInit(params: ICellRendererParams): void {
    if (params.value) {
      this.value = new Date(params.value).toLocaleDateString();
    }
  }
  refresh(params: ICellRendererParams<any, any>): any {
    return false;
  }
}
